export default __webpack_public_path__ + "static/media/del-content.8be5281e.jpg";